module.exports = __webpack_public_path__ + "img/thumbnail_DungBeetle_u_normal.d6875589.png";